module.exports = __webpack_public_path__ + "img/img2.a22d2981.png";